module.exports = __webpack_public_path__ + "img/deck-en.1dd32adb.svg";